<template>
  <transition name="fade" @enter="show=false" :duration="duration">
    <div class="dtmf-key-mask"
      v-if="show">
      {{ keyPressed }}
    </div>
  </transition>
</template>

<script>
export default {
  name: 'dtmf-mask',
  data () {
    return {
      duration: 160,
      show: false,
      keyPressed: ''
    }
  },
  props: {
    ready: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  mounted () {
    window.addEventListener('keyup', (e) => this.kbdKeyUp(e.key))
  },
  methods: {
    kbdKeyUp: function (key) {
      this.keyPressed = ''

      if (key === 'Escape') {
        this.$emit('close-on-escape')
        return
      }

      if (!this.ready) return

      if (key.match(/^[0-9*#]$/)) {
        this.keyPressed = key
      }
      // use Enter as # to terminate input
      if (key === 'Enter') {
        this.keyPressed = '#'
      }

      if (this.keyPressed) {
        this.show = true
        this.$emit('keypress', this.keyPressed)
      }
    }
  }
}
</script>

<style scoped>
.dtmf-key-mask {
  opacity: .2;
  left: 0;
  z-index: 10;
  position: absolute;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  font-weight: 900!important;
  font-size: 152px!important;
}
</style>
